/* eslint-disable array-callback-return */
import { useSnackbar } from 'notistack';
import { connect, useDispatch, useSelector } from 'react-redux';
import LogRocket from 'logrocket';

import { decodeHTMLEntities } from './common/Formatter';
import {
  aerosActions,
  geofencesActions,
  groupsActions,
  pointActions,
  sessionActions,
  usersActions
} from './store';
import { useEffectAsync } from './reactHelper';
import { getItem, getItemWithoutHeaders } from './fetch';
import {
  selectAuthenticatedUser,
  selectSession,
  selectGroupSelectedId,
  selectGroupsArray,
  selectAerosArray
} from './createSelectorUtils';

function CachingController() {
  const { enqueueSnackbar } = useSnackbar();
  const authenticated = useSelector(selectAuthenticatedUser);
  const session = useSelector(selectSession);
  const groupId = useSelector(selectGroupSelectedId);

  const permission =
    session.permission && session.permission.length !== 0
      ? session.permission.find((item) => item.groupid === groupId) || {}
      : {};

  const groups = useSelector(selectGroupsArray);
  const aeros = useSelector(selectAerosArray);

  const dispatch = useDispatch();

  useEffectAsync(async () => {
    if (authenticated) {
      const responseUsers = await getItem('users');
      if (responseUsers.ok) {
        const resultatUsers = await responseUsers.json();
        resultatUsers.map((t) => {
          t.name = decodeHTMLEntities(t.name);
          t.prenom = decodeHTMLEntities(t.prenom);
        });
        dispatch(usersActions.initial(await resultatUsers));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await getItem(session.administrator ? `groups?all=true` : 'groups');
      if (response.ok) {
        dispatch(groupsActions.update(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated && groups) {
      try {
        if (groupId === 0 && session.aero) {
          const aeroPosition = aeros.find((aero) => aero.oaci === session.aero);
          if (aeroPosition) {
            dispatch(groupsActions.updateClubLatLong([aeroPosition.lon, aeroPosition.lat]));
            return null;
          }
        } else {
          const group = groups.find((item) => item.id === groupId) || {};

          if (group && group.aero) {
            const aeroPosition = aeros.find((aero) => aero.oaci === group.aero);
            if (aeroPosition) {
              dispatch(groupsActions.updateClubLatLong([aeroPosition.lon, aeroPosition.lat]));
              return null;
            }
          }
        }
      } catch (e) {
        enqueueSnackbar(e, { variant: 'error' });
      }
    }
    dispatch(groupsActions.updateClubLatLong(await [2.33333, 48.86666]));
    return null;
  }, [authenticated, groupId, groups.length, aeros.length]);

  useEffectAsync(async () => {
    if (authenticated) {
      if (
        (permission.status === 3 || permission.status === 4 || groupId === 0) &&
        !session.administrator
      ) {
        const responseExpired = await getItemWithoutHeaders('session/expired');
        if (responseExpired.ok) {
          const result = await responseExpired.json();
          if (!result) {
            dispatch(sessionActions.abonnement(await true));
          } else {
            dispatch(sessionActions.abonnement(await false));
            const responseFreeFlights = await getItemWithoutHeaders('session/free/flights');
            if (responseFreeFlights.ok) {
              dispatch(sessionActions.lastFreeFlight(await responseFreeFlights.json()));
            }
          }
        } else {
          dispatch(sessionActions.abonnement(await false));
        }
      } else {
        dispatch(sessionActions.abonnement(await true));
      }
    }
  }, [authenticated, groupId]);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await getItem('geofences');
      if (response.ok) {
        dispatch(geofencesActions.update(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated && session.administrator) {
      const response = await fetch(`/api/group/token`);
      if (response.ok) {
        dispatch(groupsActions.updateToken(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await getItem('aeros');
      if (response.ok) {
        dispatch(aerosActions.initial(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await getItemWithoutHeaders('session/point');
      if (response.ok) {
        dispatch(pointActions.update(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await getItemWithoutHeaders('session/aero');
      if (response.ok) {
        dispatch(aerosActions.updateVisited(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await getItem('aeros/runways');
      if (response.ok) {
        dispatch(aerosActions.initialRunways(await response.json()));
      }
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      LogRocket.identify(session.id, {
        name: `${session.name} ${session.prenom}`,
        email: session.email

        // Add your own custom user variables here, ie:
      });
    }
  }, [authenticated]);

  return null;
}

export default connect()(CachingController);
